import React from "react";

function Button({
  className = "",
  variant = "default",
  size = "default",
  asChild = false,
  ...props
}) {
  const Comp = asChild ? "span" : "button";

  const baseClasses =
    "btn d-inline-flex align-items-center justify-center gap-2 text-sm fw-medium transition border-0 rounded";

  const variantClasses = {
    default: "btn-primary",
    destructive: "btn-danger",
    outline: "btn-outline-secondary",
    secondary: "btn-secondary",
    ghost: "btn-light border-0 bg-transparent",
    link: "btn-link text-primary text-decoration-underline-hover",
  };

  const sizeClasses = {
    default: "px-4 py-2 h-auto",
    sm: "px-3 py-1 text-sm",
    lg: "px-4 py-2 fs-5",
    icon: "p-2 btn-icon", // you can define `.btn-icon` for fixed square icons
  };

  const combinedClasses = `${baseClasses} ${variantClasses[variant] || ""} ${
    sizeClasses[size] || ""
  } ${className}`.trim();

  return <Comp className={combinedClasses} data-slot="button" {...props} />;
}

export { Button };
